import React from "react";
import { useSelector } from "react-redux";
import { makeStyles, Grid, Typography, Box } from "@material-ui/core";
import { useState, useEffect } from "react";
import { commonService } from "../../../services/common.service";
import { adminService } from "../../../services/admin.service";
import { grey100 } from "material-ui/styles/colors";
import { useTranslation } from "react-i18next";
import { Skeleton } from "@material-ui/lab";
const useStyle = makeStyles((theme) => ({
  image: {
    margin: "1rem"
  },
  box: {
    justify: "center",
    backgroundColor: grey100,
    border: "1px dashed" + theme?.palette?.eRich?.base,
    margin: '1rem'
  },
  technicalLabel: {
    fontWeight: "bold"
  },
  inProgressLabel: {
    color: theme?.palette?.eTertiary?.base,
    fontWeight: "bold"
  },
  content: {
    margin: '2rem',
  },
  revistContent: {
    color: theme?.palette?.ePrimary?.base,
    fontWeight: "bold",
    margin: "1rem"
  },margin:{
    [theme.breakpoints.up("md")]: {
        marginTop:"4%"
    },
}
}))

export default function EApplicationReview({response}) {
  const trackClass = useStyle();
  const { t: trackConnectionLabel, ready: labelReady } = useTranslation("label-E_TRACKING_NEW_CONNECTION");
  const { t: content, ready: contentReady } = useTranslation("content-E_TRACK_CONNECTION_REQUEST")
  const { t: titlelabels, ready: titlelabelsReady } = useTranslation("label-NESCO_TRACK_REQUEST");
  const [trackLoadingImagePath, setTrackLoadingImagePath] = useState("");
  let trackLoadingImage = useSelector((store) => store?.parametersWidgets?.ParameterLookup?.E_TRACKING_LOADING);
  useEffect(() => {
    if (trackLoadingImage) {
      commonService.getAssestUrl(trackLoadingImage).then((response) => {
        setTrackLoadingImagePath(response);
      })
    }
  }, [trackLoadingImage]);

  return (
    <>
      <Grid container justify='center' className={trackClass.margin}>
        <Grid item >
          {trackLoadingImagePath && (
            <img
              className={trackClass.image}
              src={trackLoadingImagePath?.assetPath}
              alt={labelReady
                ? trackConnectionLabel("E_TRACKING_FALLBACK_IMAGE")
                : ""}
            />
          )}
        </Grid>  
      <Grid container justify='center'>
        <Grid item>
          <Box className={trackClass.box}>
          {titlelabelsReady ? <Typography variant="body2" className={trackClass.content}>
          <span className={trackClass.technicalLabel}>{response?.status === "ICXNC7"?titlelabels("E_TRACKING_POST_INSTALLATION"):titlelabels("E_TRACKING_APPLICATION_REVIEW")}</span> {trackConnectionLabel("E_TOWARDS_NEW_CONNECTION")} <span className={trackClass.inProgressLabel}>{trackConnectionLabel("E_IN_PROGRESS")}</span>            </Typography>:""}
          </Box>
        </Grid>
      </Grid>
      <Grid container justify='center'>
        <Grid item className={trackClass.revistContent}>
        {contentReady ?
            <Typography
              variant="subtitle2"
              dangerouslySetInnerHTML={{
                __html: content("E_TRACK_REVIST_CONTENT").answer,
              }}
            ></Typography>
            : <Skeleton />}
        </Grid>
      </Grid>
      </Grid>
    </>
  )
}